<ion-content class="">
  <div class="scroll-content-modal">
    <app-header-modal [title]="event?.name || 'Evento de reciclaje'" [showToggle]="true" [showClose]="true"
      [bgColor]="'var(--color-gray-100)'" (toggleHeight)="toggleModalHeight()" (close)="closeModal()">
    </app-header-modal>

    @if (event) {
    <div class="modal-content">
      <div class="card-content">
        <!-- Event Type Badge -->
        <div class="type-badge-section section-margin-2xs">
          <div class="type-badge badge-event">
            <img class='icon icon-20 icon-event margin-r-xs' [src]="getEventIcon()" alt="Evento">
            <span class="type-label p-semibold">{{ eventTypeLabel() }}</span>
          </div>
        </div>

        <!-- Event Date & Time -->
        @if (hasEventScheduleInfo()) {
        <div class="event-datetime-section section-margin-2xs">
          <app-event-date-range
            [startsAt]="$any(event).startsAt"
            [endsAt]="$any(event).endsAt">
          </app-event-date-range>
        </div>
        }

        <!-- Address Section + Trust/Source icons -->
        @if (addressString()) {
        <div class="info-row section-margin-2xs clickable" (click)="repointMapOnEvent($event)">
          <div class="row-content address-field">
            <img class='icon icon-event margin-r-xs icon-20' src="assets/icons/location.svg" alt="Location">
            <p class="row-text p notranslate" translate="no">{{ addressString() }}</p>
            <app-trust-source-badge
              [validation]="event.validation"
              [dataSource]="event.dataSource">
            </app-trust-source-badge>
          </div>
        </div>
        }

        <!-- Description Section -->
        @if (event.description) {
        <div class="description-section section-margin-2xs">
          <app-leer-mas [text]="event.description" [lineClamp]="3" [threshold]="150">
          </app-leer-mas>
        </div>
        }

        <!-- Materials Section -->
        <app-modal-materials-section
          [materialInput]="inputMaterials()"
          [materialOutput]="outputMaterials()">
        </app-modal-materials-section>

        <!-- Schedule Section (if has recurring schedule) -->
        @if (event.schedules && event.schedules.length > 0) {
        <div class="schedule-section section-margin-s">
          <div class="section-title margin-b-xs">
            <span class="b-semibold color-text-secondary">{{ 'eventModal.schedules' | t }}</span>
          </div>
          <app-schedule [scheduleData]="event.schedules" variant="modal" [showStatus]="true" [showHours]="true"
            [showDayPills]="true" customClasses="sub margin-t-s">
          </app-schedule>
        </div>
        }

        <!-- Reference Links + Website -->
        <div class="section-margin-xs">
          <app-links-chips [links]="event.referenceLinks || []" [website]="event.sitio_web" [maxVisible]="4">
          </app-links-chips>
        </div>

        <!-- Contact Information -->
        <app-contact-info [phone]="event.telefono || event.contactPhone"
          [email]="event.contactEmail" (contactAction)="onContactAction($event)">
        </app-contact-info>

        <!-- Action Buttons Slider -->
        <div class="action-slider-section">
          <app-action-buttons-slider [actions]="actionButtons" (actionClick)="onActionButtonClick($event)">
          </app-action-buttons-slider>
        </div>

        <!-- Suggest Edit Button (only when lacking materials, address, or schedule) -->
        @if (shouldShowEditButton()) {
        <div class="button-section section-margin-sm">
          <div class="btn-edit push-btn primary-invert-color-button full-width-button btn-sm" (click)="suggestEdit()">
            <button class="inner-button edit p" [title]="'eventModal.suggestEdit' | t">
              <img src="assets/icons/edit.svg" class="icon-primary icon-20" alt="">
              <span class='btn-text p-semibold line-clamp-1'>{{ 'eventModal.editAddInfo' | t }}</span>
            </button>
          </div>
        </div>
        }


        <!-- Social Section (reports + status + comments) -->
        <div class="">
          <app-social-section
            [entityId]="event.id"
            entityType="event">
          </app-social-section>
        </div>

      </div>
    </div>
    }
    <div class="spacing-100"></div>
  </div>
</ion-content>

<!-- Action Sheet for Share Options -->
<ion-action-sheet [isOpen]="isActionSheetOpen" [buttons]="actionSheetButtons" (didDismiss)="isActionSheetOpen = false">
</ion-action-sheet>